import { createTheme } from "@material-ui/core";

export default createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#F22F46",
    },
    //background:'#fff',
  },
  typography: {
    fontFamily: "Montserrat-Regular",
  },
  // typography: {
  //   fontFamily: 'inherit',
  // },

  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14,
        fontWeight: 600,
      },
    },
    MuiTab: {
      root: {
        "@media (min-width: 600px)": {
          minWidth: 60,
        },
        padding: 6,
      },
    },

    MuiIcon: {
      root: {
        height: "1.15em",
      },
    },
  },
});
